import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';
import { CerFormViewSet } from '@form/cer-form-view-set';

export class PartyRoleForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {
    viewSet.viewAdd(this.viewGet());
  }

  private viewGet(): CerFormView {

    const view = new CerFormView();

    view.viewMetadata = {
      name: 'kontakt-roller', dataApiName: 'PartyRole', text: 'Kontaktroller',
      primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history']
    };

    view.fieldMetadata = [
      { name: 'isContract', text: 'Kontrakt', tooltipText: 'Kan tilknyttes kontrakter?', format: 'CheckBox', defaultValue: false },
      { name: 'isProduct', text: 'Udgivelse', tooltipText: 'Kan tilknyttes udgivelser?', format: 'CheckBox', defaultValue: false },
      { name: 'isVendor', text: 'Leverandør', tooltipText: 'Anvendes ved leverandør?', format: 'CheckBox', defaultValue: false },
      { name: 'isReviewer', text: 'Anmelder', tooltipText: 'Anvendes ved anmeldere?', format: 'CheckBox', defaultValue: false },
      { name: 'onix', text: 'ONIX' },
    
    ];

    return view;
  }
}
